import { useResponsive } from '@ghq-abi/design-system';

import { DesktopMenu, ErrorBoundary, Header } from '~/core/components';
import { useStellarWidget } from '~/shared/hooks/useStellarWidget';

import { StyledContent, StyledWrapper } from './styles';

type AppTemplateProps = {
  children: React.ReactNode;
};

export function AppTemplate({ children }: AppTemplateProps) {
  useStellarWidget();

  const { isMobile } = useResponsive({ useOnlyAbiTokens: true });

  return (
    <>
      <Header />

      <StyledWrapper>
        {!isMobile && <DesktopMenu />}

        <ErrorBoundary inApp>
          <StyledContent>{children}</StyledContent>
        </ErrorBoundary>
      </StyledWrapper>
    </>
  );
}
